import React from "react";
import {
  Button,
} from "reactstrap";

export default function CommandButtons({
  modalFilterDataControl,
  setModalFilterDataControl,
  getTrashDataAndOpenModal,
  getErrorsDataAndOpenModal,
  openNewAction,
}) {
  return (
    <div style={{ paddingBottom: 5, flexDirection: 'row', display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
      <div style={{ padding: 2 }}>
        <Button
          color="primary"
          onClick={() => openNewAction()}
        >
          <span class="mdi mdi-plus" style={{ paddingRight: 5, fontSize: 17 }}></span>
          Cadastrar Ação
        </Button>
      </div>
      <div style={{ padding: 2 }}>
        <Button
          color="info"
          onClick={() => setModalFilterDataControl({ ...modalFilterDataControl, open: true })}
        >
          <span class="mdi mdi-filter" style={{ paddingRight: 5, fontSize: 17 }}></span>
          Filtrar
        </Button>
      </div>
      <div style={{ padding: 2 }}>
        <Button
          color="secondary"
          onClick={() => getTrashDataAndOpenModal()}
        >
          <span class="mdi mdi-trash-can" style={{ paddingRight: 5, fontSize: 17 }}></span>
          Excluídos
        </Button>
      </div>
      <div style={{ padding: 2 }}>
        <Button
          color="warning"
          onClick={() => getErrorsDataAndOpenModal()}
        >
          <span class="mdi mdi-alert" style={{ paddingRight: 5, fontSize: 17 }}></span>
          Erros
        </Button>
      </div>
    </div>
  )
}
